import cn from "classnames"

import { CodeOutlined } from "@/icons"
import { getSpecialSymbol } from "@/organisms/SmartSearch/helpers/option.helpers"
import { ItemListTemplate } from "../../templates/ItemListTemplate"
import { DescriptionItem } from "../DescriptionItem"

export const HelperList = (props: any) => {
  const { services, onClick } = props
  const { FilterService, StringService } = services
  const currentToken = StringService.getTokenByCaretPos()
  const currentLabel = currentToken?.id
  const filter = FilterService.getFilterByLabel(currentLabel)

  if (!filter) return null

  const title = "helper"
  const className = "item-smart-search-ks helper-item-smart-search-ks"
  const { helper, linkedKey } = filter
  const ids = linkedKey ? StringService.getIds() : []
  const helpers = linkedKey
    ? FilterService.getHelpersByLinkedKey(linkedKey).reduce(
        (acc: [], filterByHelper: { label: string; helper: unknown[] }) => {
          const length = ids.filter(
            (id: string) => id === filterByHelper.label
          ).length
          const disabled =
            filter.label !== filterByHelper.label ? length > 0 : length > 1

          return [
            ...acc,
            ...(filterByHelper.helper || []).map((helper: any) => ({
              disabled,
              filter: filterByHelper,
              ...helper
            }))
          ]
        },
        []
      )
    : helper
  const getLabel = (label?: string | string[]) => {
    if (Array.isArray(label))
      return (
        <ul className="ol-list-helper-item-list">
          {label.map((value, index) => (
            <li key={index}>{value}</li>
          ))}
        </ul>
      )

    return label?.split(":").map((value, index) => (
      <span
        key={`${index}_${value}`}
        className={cn(!index && "capitalize-text-ks")}
      >
        {`${index > 0 ? ":" : ""}${value}`}
      </span>
    ))
  }

  if (helpers)
    return (
      <ItemListTemplate title={title} Icon={CodeOutlined}>
        {helpers.map(
          (
            {
              filter,
              description,
              disabled,
              label = currentLabel
            }: {
              label?: string | string[]
              description: string
              filter: any
              disabled?: boolean
            },
            index: number
          ) => {
            const handler = (event: MouseEvent | KeyboardEvent) => {
              const { code } = event as KeyboardEvent

              if (code === "ArrowDown" || code === "ArrowUp") return

              if (filter.label === currentLabel)
                return onClick({
                  replaceByIndex: StringService.findTokenIndexByCaretPos()
                })

              const currentToken = StringService.getTokenByCaretPos()

              StringService.setTokens(
                StringService.getTokens().map((token: any) => {
                  if (token.startCaretPos === currentToken?.startCaretPos) {
                    const { delimiter = "", value = "" } = token

                    return {
                      ...token,
                      str: `${filter.label}${delimiter}${value}`,
                      id: filter.id,
                      label: filter.id
                    }
                  }
                  return token
                })
              )
              StringService.setText(
                StringService.buildTextFromTokens()
              ).tokenizer()
              StringService.setCaretPos(
                StringService.getTokens().filter(
                  (token: any) =>
                    token.startCaretPos === currentToken.startCaretPos
                )?.[0]?.endCaretPos
              )
              StringService.updateDataByCaretPos()

              onClick({
                replaceByIndex: StringService.findTokenIndexByCaretPos()
              })
            }
            const active = linkedKey && !disabled

            return (
              <DescriptionItem
                tabIndex={active ? 1 : 0}
                key={index}
                className={cn(className, {
                  "inequality-item-smart-search": active,
                  "disabled-item-smart-search": !active
                })}
                description={description}
                handler={active ? handler : undefined}
              >
                {linkedKey && (
                  <>
                    {index === 0 && (
                      <span className="inequality-label-smart-search">
                        {getSpecialSymbol(label?.toString())}
                      </span>
                    )}
                    <span>{getLabel(label.slice(index === 0 ? 1 : 0))}</span>
                  </>
                )}
                {!linkedKey && getLabel(label)}
              </DescriptionItem>
            )
          }
        )}
      </ItemListTemplate>
    )

  const { type } = filter

  if (type === "multiple")
    return (
      <ItemListTemplate title={title} Icon={CodeOutlined}>
        <DescriptionItem
          tabIndex={0}
          className={className}
          description="Equals value1 OR value2"
        >
          {`${currentLabel}:value1,value2`}
        </DescriptionItem>
      </ItemListTemplate>
    )

  return null
}
